import { render } from "./AnrDevLoansGrants.vue?vue&type=template&id=097a05a2"
import script from "./AnrDevLoansGrants.vue?vue&type=script&lang=js"
export * from "./AnrDevLoansGrants.vue?vue&type=script&lang=js"

import "./AnrDevLoansGrants.vue?vue&type=style&index=0&id=097a05a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__